import {useAppSelector} from "../../redux/hooks";
import {settingsStore} from "../../redux/settings/settingsStore";
import settingsService from "../../services/settings/settingsService";

// This is intended to replace IKeyboardAndVolumes as the view model for the "Keyboard & Volumes" page
export interface IKeyboardAndVolumesPageLogic {
  midiDevice: {
    currentlySelectedMidiDevice: string,
  }
}

export const useKeyboardAndVolumesPageLogic = (): IKeyboardAndVolumesPageLogic => {
  const currentlySelectedMidiDeviceIdFromLocalStorage = settingsService.getCurrentlySelectedMidiDeviceId();
  const currentlySelectedMidiDeviceId = useAppSelector(() => {
    const currentlySelectedMidiDeviceIdFromRedux = settingsStore.getSelectedMidiDeviceId();
    return currentlySelectedMidiDeviceIdFromRedux === currentlySelectedMidiDeviceIdFromLocalStorage
      ? currentlySelectedMidiDeviceIdFromLocalStorage
      : currentlySelectedMidiDeviceIdFromRedux;
  });

  return {
    midiDevice: {
      currentlySelectedMidiDevice: currentlySelectedMidiDeviceId,
    },
  };
}
